import { render, staticRenderFns } from "./kk3.vue?vue&type=template&id=44f25742&"
import script from "./kk3.vue?vue&type=script&lang=js&"
export * from "./kk3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QPageContainer,QCard,QCardSection,QBtn,QInput,QMarkupTable,QItem,QItemSection,QItemLabel,QTooltip,QBadge,QExpansionItem,QList,QIcon,QSpinnerPie,QPagination,QSelect,QSpinnerFacebook,QSeparator,QRadio,QFile,QDialog,QCardActions,QChatMessage,QEditor,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QPageContainer,QCard,QCardSection,QBtn,QInput,QMarkupTable,QItem,QItemSection,QItemLabel,QTooltip,QBadge,QExpansionItem,QList,QIcon,QSpinnerPie,QPagination,QSelect,QSpinnerFacebook,QSeparator,QRadio,QFile,QDialog,QCardActions,QChatMessage,QEditor})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
